import API from "../../../../../global/api";
import jsPDF from "jspdf";
import moment from "moment";
import { isEmpty } from "lodash";
import { changeDateFormate, handleNoDataVisible, PDFHeader } from "../../../../../global/globalFunctions";
import { getProductData } from "../AddProduct/Product.action";


export const requestAddOrder = () => {
  return {
    type: "REQUEST_ADD_ORDER",
  };
};
export const successAddOrder = (data) => {
  return {
    type: "SUCCESS_ADD_ORDER",
    payload: data,
  };
};
export const errorAddOrder = () => {
  return {
    type: "ERROR_ADD_ORDER",
  };
};
export const AddOrderBookingApi = (data, showSuccessAlert, showErrorAlert) => {
  return (dispatch) => {
    dispatch(requestAddOrder());
    API.post(`/booking/add-booking`, data)
      .then((res) => {
        dispatch(getProductData());
        dispatch(successAddOrder(data));
        showSuccessAlert(res.data.message);
      }).catch((error) => {
        dispatch(errorAddOrder());
        showErrorAlert(error.response.data.message);
      });
  };
};


export const clearShopLedger = () => ({
  type: "CLEAR_SHOP_LEDGER",
});


export const requestGetOrder = () => {
  return {
    type: "REQUEST_GET_ORDER",
  };
};
export const successGetOrder = (data) => {
  return {
    type: "SUCCESS_GET_ORDER",
    payload: data,
  };
};
export const errorGetAllOrder = () => {
  return {
    type: "ERROR_GET_ORDER",
  };
};
export const getOrder = (data) => {
  return (dispatch) => {
    dispatch(requestGetOrder());
    API.get(`/booking?limit=1000&page=0&search`)
      .then((res) => {
        let data1 = res.data;
        dispatch(successGetOrder(data1));
      }).catch((error) => {
        dispatch(errorGetAllOrder());
      });
  };
};


export const UpdateRequestOrder = () => {
  return {
    type: "UPDATE_REQUEST_ORDER",
  };
};
export const UpdateSuccessOrder = (data) => {
  return {
    type: "UPDATE_SUCCESS_ORDER",
    payload: data,
  };
};
export const UpdateErrorOrder = () => {
  return {
    type: "UPDATE_ERROR_ORDER",
  };
};
export const updateOrder = (data, handleVisible, handleDangerVisible) => {
  return (dispatch) => {
    dispatch(UpdateRequestOrder());
    return API.put(`/booking/${data._id}`, data)
      .then((res) => {
        dispatch(UpdateSuccessOrder(res.data));
        handleVisible(res.data.message);
        return res.data;
      }).catch((error) => {
        dispatch(UpdateErrorOrder());
        const errorMsg = error.response?.data?.message || "Update failed";
        handleDangerVisible(errorMsg);
        throw error;
      });
  };
};


export const DeleteRequestOrder = () => {
  return {
    type: "DELETE_REQUEST_ORDER",
  };
};
export const DeleteSuccessOrder = (id) => {
  return {
    type: "DELETE_SUCCESS_ORDER",
    id: id,
  };
};
export const DeleteErrorOrder = () => {
  return {
    type: "DELETE_ERROR_ORDER",
  };
};
export const DeleteOrderApi = (id, updateTableQuery) => {
  return (dispatch) => {
    dispatch(DeleteRequestOrder());
    API.delete(`/booking/${id}`)
      .then((res) => {
        dispatch(DeleteSuccessOrder(id));
        updateTableQuery()
      }).catch((error) => {
        dispatch(DeleteErrorOrder());
      });
  };
};


export const requestSearchAccountLedgerTable = () => {
  return {
    type: "REQUEST_GET_SHOP_LEDGER",
  };
};
export const successSearchAccountLedgerTable = (data) => {
  return {
    type: "SUCCESS_GET_SHOP_LEDGER",
    payload: data,
  };
};
export const errorSearchAccountLedgerTable = () => {
  return {
    type: "ERROR_GET_SHOP_LEDGER",
  };
};
export const searchAccountLedgerTable = (data, startDate, endDate, accountName) => {
  return (dispatch) => {
    dispatch(requestSearchAccountLedgerTable());
    API.post(`/levelFour/account_ledger_with_shopId`, data)
      .then((res) => {
        let getData = res.data;
        dispatch(successSearchAccountLedgerTable(getData));
      }).catch((error) => {
        dispatch(errorSearchAccountLedgerTable());
      });
  };
};


export const generateOrderPDF = (orderData) => {
  return (dispatch) => {
    const unit = "pt";
    const size = "A4";
    const orientation = "p";
    const doc = new jsPDF(orientation, unit, size);
    PDFHeader(doc, "");

    doc.setFont("TimesNewRoman", "Normal");
    doc.setFontSize(11);
    doc.rect(350, 105, 190, 40);
    doc.text(`Invoice: ${orderData?.number}`, 380, 120, 0, 20);
    doc.text(`Date: ${changeDateFormate(orderData?.orderDate)}`, 380, 135, 0, 20);
    // doc.text(`Filer Status: ${orderData?.shopId?._id?.filerStatus === true ? 'Active' : 'Inactive'}`, 380, 150, 0, 20);

    doc.rect(15, 85, 287, 85);
    doc.text(`Customer: ${orderData?.shopId?.shopName}`, 25, 100, 0, 20);
    doc.text(`Customer Ph: ${orderData?.shopId?.ownerNumber}`, 25, 115, 0, 20);
    doc.text(`Area: ${orderData?.areaId?.areaName}`, 25, 130, 0, 20);
    doc.text(`DSF: ${orderData?.bookerId?.userName}`, 25, 145, 0, 20);
    doc.text(`Shop Location: ${orderData?.shopId?.location}`, 25, 160, 0, 20);

    const headers = [[
      "S.No",
      "Code",
      "Product Name",
      "Quantity",
      "Rate",
      "Total",
    ]];
    const data = orderData?.items.map((x, i) => [
      i + 1,
      x.code,
      x.productLabel,
      x.quantity,
      x.salePrice,
      Number(x.salePrice) * Number(x.quantity),
    ]);
    let content = {
      margin: {
        left: 12,
        right: 35,
      },
      startY: 175,
      styles: {
        fontSize: 9,
        lineColor: [0, 0, 0],
        lineWidth: 0.2,
      },
      head: headers,
      body: data,
      theme: 'grid',
    };
    doc.autoTable(content);

    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    let finalY = doc.lastAutoTable.finalY;
    doc.line(20, finalY + 40, 170, finalY + 40);
    doc.text("Customer Signature", 40, finalY + 60);
    doc.setFont("TimesNewRoman", "bold");
    doc.text(`Closing Balance: ${orderData.shopOldBalance || 0}`, 250, finalY + 25);
    doc.setFont("TimesNewRoman", "Normal");
    doc.rect(420, finalY + 10, 140, 65);
    doc.text(`Grand Total: ${orderData.subTotal}`, 430, finalY + 25);
    doc.text(`Discount: ${orderData?.discount}`, 430, finalY + 40);
    doc.text(`Tax (${orderData?.tax}%): ${orderData?.taxAmount}`, 430, finalY + 55);
    doc.text(`Net Total: ${orderData.grandTotal}`, 430, finalY + 70);


    doc.setProperties(`Order Print ${moment().format("YYYY-MM-DD")}`);
    var blob = doc.output("blob");
    window.open(URL.createObjectURL(blob));
  }
};


export const requestGetAllOrderByBookerId = () => {
  return {
    type: "REQUEST_GET_ALL_ORDER_BY_BOOKER_ID",
  };
};
export const successGetAllOrderByBookerId = (data) => {
  return {
    type: "SUCCESS_GET_ALL_ORDER_BY_BOOKER_ID",
    payload: data,
  };
};
export const errorGetAllOrderByBookerId = () => {
  return {
    type: "ERROR_GET_ALL_ORDER_BY_BOOKER_ID",
  };
};
export const generateAllOrderPDF = (data) => {
  return (dispatch) => {
    dispatch(requestGetAllOrderByBookerId());
    API.post(`/booking/booking_report`, data)
      .then((res) => {
        const unit = "pt";
        const size = "A4";
        const orientation = "p";
        const doc = new jsPDF(orientation, unit, size);

        doc.setDrawColor(0);
        doc.setLineWidth(0.5);

        res.data.data.map((x, i) => {
          PDFHeader(doc, "");
          doc.setFont("TimesNewRoman", "Normal");
          doc.setFontSize(11);

          doc.rect(350, 105, 190, 40);
          doc.text(`Invoice # : ${x.number}`, 380, 120, 0, 20);
          doc.text(`Date : ${changeDateFormate(x.orderDate)}`, 380, 135, 0, 20);

          doc.rect(15, 85, 287, 85);
          doc.text(`Customer: ${x.shopId.shopName}`, 25, 100, 0, 20);
          doc.text(`Customer Ph: ${x.shopId.ownerNumber}`, 25, 115, 0, 20);
          doc.text(`Area: ${x.areaId.areaName}`, 25, 130, 0, 20);
          doc.text(`DSF: ${x.bookerId.userName}`, 25, 145, 0, 20);
          doc.text(`Shop Location: ${x.shopId.location}`, 25, 160, 0, 20);

          const headers = [[
            "S.No",
            "Code",
            "Product Name",
            "Quantity",
            "Rate",
            "Total",
          ]];
          const orderData = x.items.map((y, j) => [
            j + 1,
            y.code,
            y.productLabel,
            y.quantity,
            y.salePrice,
            Number(y.salePrice) * Number(y.quantity),
          ]);
          let content = {
            margin: {
              left: 12,
              right: 35,
            },
            startY: 175,
            styles: {
              fontSize: 9,
              lineColor: [0, 0, 0],
              lineWidth: 0.5,
              cellPadding: 5
            },
            head: headers,
            body: orderData,
            theme: 'grid',
            headStyles: {
              lineWidth: 0.5,
              lineColor: [0, 0, 0]
            },
            bodyStyles: {
              lineWidth: 0.5,
              lineColor: [0, 0, 0]
            }
          };
          doc.autoTable(content);

          let finalY = doc.lastAutoTable.finalY;

          doc.setDrawColor(0);
          doc.setLineWidth(0.5);

          doc.line(20, finalY + 40, 170, finalY + 40);
          doc.text("Customer Signature", 40, finalY + 60);

          doc.setFont("TimesNewRoman", "bold");
          doc.text(`Closing Balance: ${x.shopOldBalance || 0}`, 250, finalY + 25);
          doc.setFont("TimesNewRoman", "Normal");

          doc.rect(420, finalY + 10, 140, 65);
          doc.text(`Grand Total: ${x.subTotal}`, 430, finalY + 25);
          doc.text(`Discount: ${x.discount}`, 430, finalY + 40);
          doc.text(`Tax (${x.tax}%): ${x.taxAmount}`, 430, finalY + 55);
          doc.text(`Net Total: ${x.grandTotal}`, 430, finalY + 70);

          // Add new page if not the last order
          if (res.data.data.length - 1 !== i) {
            doc.addPage();
            doc.setDrawColor(0);
            doc.setLineWidth(0.5);
          }
        })

        doc.setProperties(`Order Booking Report ${moment().format("YYYY-MM-DD")}`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
        dispatch(errorGetAllOrderByBookerId(res.data));
      }).catch((error) => {
        dispatch(errorGetAllOrderByBookerId());
      });
  }
};


export const requestLoadForm = () => {
  return {
    type: "REQUEST_GET_ALL_ORDER_BY_BOOKER_ID",
  };
};
export const successLoadForm = (data) => {
  return {
    type: "SUCCESS_GET_ALL_ORDER_BY_BOOKER_ID",
    payload: data,
  };
};
export const errorLoadForm = () => {
  return {
    type: "ERROR_GET_ALL_ORDER_BY_BOOKER_ID",
  };
};
export const generateLoadFormPDF = (payload) => {
  return (dispatch) => {
    dispatch(requestLoadForm());
    API.post(`/booking/load-form-report`, payload).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.items)) {
        handleNoDataVisible()
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "p";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Load Form");

        doc.setFont("TimesNewRoman", "Normal");
        doc.setFontSize(12);
        doc.text(`Start Date: ${moment(payload.startDate).format('DD-MM-YYYY')}  -  End Date: ${moment(payload.endDate).format('DD-MM-YYYY')}`, 20, 120)

        const headers = [[
          "Sr#",
          "Code",
          "Product Name",
          "Quantity",
          // "Rate",
          // "Total",
        ]];
        const data = getData.items.map((x, i) => [
          i + 1,
          x.code,
          x.productLabel,
          x.quantity,
          // x.salePrice,
          // x.quantity * x.salePrice,
        ]);
        let content = {
          margin: {
            left: 12,
            right: 35,
          },
          startY: 140,
          styles: {
            fontSize: 9,
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
          },
          head: headers,
          body: data,
          theme: 'grid',
        };
        doc.autoTable(content);

        doc.setProperties(`Load Form Report ${moment().format("YYYY-MM-DD")}`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
        dispatch(successLoadForm(getData));
      }
    }).catch((error) => {
      dispatch(errorLoadForm());
    });
  };
};


export const generateLoadFormCategoryWisePDF = (payload) => {
  return (dispatch) => {
    dispatch(requestLoadForm());
    API.post(`/booking/load-form-category-wise`, payload).then((res) => {
      let getData = res.data;
      if (isEmpty(getData.categories)) {
        handleNoDataVisible()
      } else {
        const unit = "pt";
        const size = "A4";
        const orientation = "p";
        const doc = new jsPDF(orientation, unit, size);
        PDFHeader(doc, "Load Form");

        doc.setFont("TimesNewRoman", "Normal");
        doc.setFontSize(12);
        doc.text(`Start Date: ${moment(payload.startDate).format('DD-MM-YYYY')}  -  End Date: ${moment(payload.endDate).format('DD-MM-YYYY')}`, 20, 120)

        let startY = 150;
        getData.categories.forEach((category) => {
          doc.setFontSize(12);
          doc.setFont("bold");
          doc.text(`${category.subCategoryName}`, 15, startY);
          startY += 20;

          const headers = [[
            "S.No",
            "Code",
            "Product Name",
            "Quantity",
            // "Rate",
            // "Total"
          ]];
          const tableData = category.products.map((product, index) => [
            index + 1,
            product.code,
            product.productName,
            product.quantity,
            // product.salePrice,
            // product.totalValue
          ]);
          doc.autoTable({
            startY: startY,
            head: headers,
            body: tableData,
            margin: { left: 12, right: 35 },
            styles: {
              fontSize: 9,
              lineColor: [0, 0, 0],
              lineWidth: 0.2
            },
            theme: 'grid'
          });

          startY = doc.lastAutoTable.finalY + 20;
        });

        doc.setProperties(`Load Form Report ${moment().format("YYYY-MM-DD")}`);
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
        dispatch(successLoadForm(getData));
      }
    }).catch((error) => {
      dispatch(errorLoadForm());
    });
  };
};


export const requestFilterOrder = () => {
  return {
    type: "REQUEST_FILTER_ORDER",
  };
};
export const successFilterOrder = (data) => {
  return {
    type: "SUCCESS_FILTER_ORDER",
    payload: data,
  };
};
export const errorFilterOrder = () => {
  return {
    type: "ERROR_FILTER_ORDER",
  };
};
export const OrderReportApi = (data) => {
  return (dispatch) => {
    dispatch(requestFilterOrder());
    API.post(`/booking/booking_report`, data)
      .then((res) => {
        let getData = res.data
        dispatch(successFilterOrder(getData));
      }).catch((error) => {
        dispatch(errorFilterOrder());
      });
  };
};


export const requestGetOrderById = () => {
  return {
    type: "REQUEST_GET_ORDER_BY_ID",
  };
};
export const successGetOrderById = (data) => {
  return {
    type: "SUCCESS_GET_ORDER_BY_ID",
    payload: data,
  };
};
export const errorGetAllOrderById = () => {
  return {
    type: "ERROR_GET_ORDER_BY_ID",
  };
};
export const getOrderById = (id) => {
  return (dispatch) => {
    dispatch(requestGetOrderById());
    API.get(`/booking/${id}`)
      .then((res) => {
        let data1 = res.data;
        dispatch(successGetOrderById(data1));
      }).catch((error) => {
        dispatch(errorGetAllOrderById());
      });
  };
};